// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gg-a";
export var fulfillmentFormRail = "_gg-9";
export var headerTitleRow = "_gg-c";
export var orderDetailsWrapper = "_gg-7";
export var orderLinkTrigger = "_gg-2";
export var paymentInformationGrid = "_gg-h";
export var paymentSummaryColumn = "_gg-i";
export var shipmentContainer = "_gg-b";
export var shipmentDetailsMainPane = "_gg-8";
export var shipmentNavigationCard = "_gg-5";
export var shipmentNavigationRail = "_gg-3";
export var shipmentNavigationRailHeader = "_gg-4";
export var shipmentSummaryFact = "_gg-e";
export var shipmentSummaryGrid = "_gg-d";
export var shipmentSummaryMetadataRow = "_gg-f";
export var shipmentSummaryTags = "_gg-g";
export var shipmentWorkspace = "_gg-0";
export var shipmentWorkspaceContent = "_gg-6";
export var shipmentWorkspaceHeader = "_gg-1";